import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { Button, toast } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import {
  useClassTypeQuery,
  useDeleteClassType,
  useUpdateClassType,
} from "../api/queries";
import { ClassTypeForm } from "../ui/class-types/ClassTypeForm";

export function ClassTypeEditPage() {
  const nav = useNavigate({
    from: "/app/master/class-types/$id/edit",
  });
  const { id } = useParams({ from: "/app/master/class-types/$id/edit" });
  const { data, ...result } = useClassTypeQuery(id);
  const updateClassType = useUpdateClassType(id);
  const deleteClassType = useDeleteClassType();

  const classType = data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ປະເພດຄລາດສ໌", to: "/app/master/class-types" },
            { label: "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ແກ້ໄຂປະເພດຄລາດສ໌
            </h2>
            <p className="text-muted-foreground">ປັບປຸງລາຍລະອຽດຂອງປະເພດຄລາດສ໌.</p>
          </div>

          <div className="flex gap-2">
            <Button
              variant="destructive"
              onClick={async () => {
                const ok = await import("@devhop/ui").then((m) =>
                  m.confirm({
                    title: "ລຶບປະເພດຄລາດສ໌",
                    description: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບປະເພດຄລາດສ໌ນີ້?",
                    actionText: "ລຶບ",
                    ActionProps: {
                      variant: "destructive",
                    },
                  }),
                );
                if (!ok) return;

                try {
                  await toast.promise(deleteClassType.run(id), {
                    loading: "ກຳລັງລຶບ...",
                    success: () => {
                      nav({ to: "/app/master/class-types" });
                      return "ລຶບປະເພດຄລາດສ໌ສຳເລັດ";
                    },
                    error: "ລຶບປະເພດຄລາດສ໌ລົ້ມເຫຼວ",
                  });
                } catch (error) {
                  // Error handling is done by toast.promise
                }
              }}
            >
              ລຶບ
            </Button>
            <Button
              variant="outline"
              onClick={() => nav({ to: "/app/master/class-types" })}
            >
              <ArrowLeftIcon className="size-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>

        <QueryState
          result={result}
          title="ກຳລັງໂຫຼດປະເພດຄລາດສ໌"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!classType ? null : (
            <div className="mt-6 rounded-xl border bg-card p-6">
              <ClassTypeForm
                initialValues={{
                  name: classType.name,
                  description: classType.description || "",
                  status: classType.status,
                }}
                onSubmit={async (vals) => {
                  try {
                    await updateClassType.mutateAsync(vals);

                    nav({ to: "/app/master/class-types" });
                  } catch (error) {
                    // Error handling is done by the mutation
                  }
                }}
                submitting={updateClassType.isPending}
              />
            </div>
          )}
        </QueryState>
      </Main>
    </>
  );
}
